import { render, staticRenderFns } from "./HostingPanel.vue?vue&type=template&id=b32f3974&"
import script from "./HostingPanel.vue?vue&type=script&lang=js&"
export * from "./HostingPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports